import { render } from "./Home.vue?vue&type=template&id=46c8e0d4"
import script from "./Home.ts?vue&type=script&lang=ts"
export * from "./Home.ts?vue&type=script&lang=ts"
script.render = render

export default script